import axios from 'axios';
import { ENV } from '../constants/env';

const axiosAPI = axios.create({
  baseURL: ENV.API_URL,
});

const apiRequest = (method, url, request, config = {}) => {
  let headers = {
    authorization: '',
    ...config,
  };

  return axiosAPI({
    method,
    url,
    data: request,
    headers,
  })
    .then(res => Promise.resolve(res.data))
    .catch(err => Promise.reject(err));
};

// function to execute the http get request
const get = (url, request) => apiRequest('get', url, request);

// function to execute the http delete request
const deleteRequest = (url, request) => apiRequest('delete', url, request);

// function to execute the http post request
const post = (url, request, config) => apiRequest('post', url, request, config);

// function to execute the http put request
const put = (url, request) => apiRequest('put', url, request);

// function to execute the http path request
const patch = (url, request) => apiRequest('patch', url, request);

// expose your method to other services or actions
const Request = {
  get,
  delete: deleteRequest,
  post,
  put,
  patch,
};

export default Request;
